export default __webpack_public_path__ + "static/media/hero_section.f3e94718.jpg";